import React from "react";
import { useField } from "formik";
import { CustomDateField } from "customField/partials/fields/CustomDateField";

interface IFormkPreviewFormDateProps {
  name: string;
  labelledById?: string;
}
export const FormkPreviewFormDate: React.FC<IFormkPreviewFormDateProps> = ({
  name,
  labelledById,
}) => {
  const [field, meta, helpers] = useField<string>({
    name,
  });

  return (
    <CustomDateField
      value={field.value}
      labelledById={labelledById}
      setValue={(newValue) => helpers.setValue(newValue)}
      errorMessage={meta.error}
      touched={meta.touched}
    />
  );
};
